// Contrato de payload por promotion_type nas rotas de bulk de campanha.
// Referência: doc "Payloads Bulk por Campanha" (mercadolivre-service · promotions).
//
// POST /promotions/campaigns/{promotionId}/items/bulk-add
// POST /promotions/campaigns/{promotionId}/items/bulk-remove

export const PROMOTION_TYPES = [
    'DEAL',
    'SELLER_CAMPAIGN',
    'MARKETPLACE_CAMPAIGN',
    'VOLUME',
    'SELLER_COUPON_CAMPAIGN',
    'SMART',
    'PRICE_MATCHING',
    'PRICE_MATCHING_MELI_ALL',
    'PRE_NEGOTIATED',
    'UNHEALTHY_STOCK',
    'DOD',
    'LIGHTNING',
    'PRICE_DISCOUNT'
];

export const PROMOTION_TYPES_LABELS = {
    'DEAL': 'Oferta',
    'SELLER_CAMPAIGN': 'Campanha do Vendedor',
    'MARKETPLACE_CAMPAIGN': 'Campanha do Marketplace',
    'VOLUME': 'Volume',
    'SELLER_COUPON_CAMPAIGN': 'Campanha de Cupom do Vendedor',
    'SMART': 'Inteligente',
    'PRICE_MATCHING': 'Equiparação de Preço',
    'PRICE_MATCHING_MELI_ALL': 'Equiparação de Preço (bancada pelo ML)',
    'PRE_NEGOTIATED': 'Pré-negociado',
    'UNHEALTHY_STOCK': 'Estoque Problemático',
    'DOD': 'Oferta do Dia',
    'LIGHTNING': 'Relâmpago',
    'PRICE_DISCOUNT': 'Desconto de Preço'
};

// Níveis de cada campo dentro de items[]:
//   'required'    -> sem ele o endpoint devolve 400
//   'recommended' -> o contrato do ML pede, mas o back-end resolve sozinho (custa uma chamada extra por item)
//   'optional'    -> enviado só se a planilha preencher
// Campo ausente do spec não é enviado ao ML mesmo se vier na planilha.
// add: null -> o tipo não aceita adesão por essa rota.
// item_id é sempre obrigatório e item_title é sempre opcional (só auditoria), por isso não aparecem aqui.
export const PROMOTION_PAYLOAD_SPEC = {
    DEAL: {
        add: { deal_price: 'required', top_deal_price: 'optional' },
        remove: {}
    },
    SELLER_CAMPAIGN: {
        add: { deal_price: 'required', top_deal_price: 'optional' },
        remove: {}
    },
    MARKETPLACE_CAMPAIGN: {
        // Quem precifica é o ML: o vendedor só aceita a oferta
        add: {},
        remove: { offer_id: 'recommended' }
    },
    VOLUME: {
        add: {},
        remove: { offer_id: 'recommended' }
    },
    SELLER_COUPON_CAMPAIGN: {
        add: {},
        remove: {}
    },
    SMART: {
        // offer_id na adesão é o id do CANDIDATE-...; na remoção é o OFFER-...
        add: { deal_price: 'optional', offer_id: 'recommended' },
        remove: { offer_id: 'recommended' }
    },
    PRICE_MATCHING: {
        add: { deal_price: 'optional', offer_id: 'recommended' },
        remove: { offer_id: 'recommended' }
    },
    PRICE_MATCHING_MELI_ALL: {
        // Adesão é automática no ML, não existe endpoint
        add: null,
        remove: { offer_id: 'recommended' }
    },
    PRE_NEGOTIATED: {
        add: { offer_id: 'recommended' },
        remove: { offer_id: 'recommended' }
    },
    UNHEALTHY_STOCK: {
        add: { offer_id: 'recommended' },
        remove: { offer_id: 'recommended' }
    },
    DOD: {
        add: { deal_price: 'required' },
        remove: {}
    },
    LIGHTNING: {
        // stock é a quantidade reservada para a promoção
        add: { deal_price: 'required', stock: 'required' },
        remove: {}
    },
    PRICE_DISCOUNT: {
        add: {
            deal_price: 'required',
            top_deal_price: 'optional',
            start_date: 'required',
            finish_date: 'required'
        },
        remove: {}
    }
};

export const isKnownPromotionType = (promotionType) =>
    Object.prototype.hasOwnProperty.call(PROMOTION_PAYLOAD_SPEC, promotionType);

// Retorna o spec de campos da operação, undefined para tipo desconhecido
// e null quando o tipo não aceita aquela operação.
export const getPayloadSpec = (promotionType, action) => {
    const typeSpec = PROMOTION_PAYLOAD_SPEC[promotionType];
    if (!typeSpec) return undefined;
    return action === 'remove' ? typeSpec.remove : typeSpec.add;
};

export const getRequiredFields = (promotionType, action) => {
    const spec = getPayloadSpec(promotionType, action);
    return spec ? Object.keys(spec).filter((field) => spec[field] === 'required') : [];
};
